/**
 * 应用入口组件
 */

import React from 'react';
import { AiChatModal } from './components/AiChatModal';
import { ThemeRootSync } from './components/ThemeRootSync';

interface AppProps {
  serverId: number;
  serverName: string;
  serverIp: string;
  onClose: () => void;
}

export const App: React.FC<AppProps> = (props) => {
  return (
    <>
      <ThemeRootSync />
      <AiChatModal {...props} />
    </>
  );
};
